import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';
import { sortWorkLogsByDate } from '../helpers/sort';

const DEFAULT_STATE = Immutable([]);

export default function(state = DEFAULT_STATE, action = {}) {
  let array;
  switch (action.type) {
    case ActionTypes.PROJECT_DETAILS_WORK_LOGS_FETCHED:
      array = Immutable.asMutable(state.concat(action.workLogs));
      sortWorkLogsByDate(array);
      return Immutable(array);
    case ActionTypes.PROJECT_DETAILS_WORK_LOGS_CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projectDetails.js